<template>
  <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onCreate">
    <v-card tile>
      <v-card-title class="grey lighten-2">
        Skapa bemanningsavvikelse
      </v-card-title>

      <v-card-text class="mt-2">
        <CrewActivitySearch />
        <CrewLocationFields />
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer />
        <v-btn rounded @click="closeModal">Avbryt</v-btn>
        <v-btn rounded type="submit" color="primary" :loading="createPending">
          Skapa bemanningsavvikelse
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import gql from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { required, validDate } from '@/common/validationRules'
import CrewActivitySearch from './CrewForm/CrewActivitySearch.vue'
import CrewLocationFields from './CrewForm/CrewLocationFields.vue'

export default {
  name: 'CrewCreateModal',

  components: {
    CrewActivitySearch,
    CrewLocationFields
  },

  data: () => ({
    required,
    validDate,
    valid: true,
    datepicker: false,
    createPending: false
  }),

  created() {
    this.$store.set(
      'crew/model@event_uuid',
      this.$store.get('event/selectedUUID')
    )
  },

  computed: {
    model: sync('crew/model')
  },

  methods: {
    async onCreate() {
      const isValidForm = await this.$refs.form.validate()
      if (!isValidForm) return
      this.createPending = true

      await this.$apollo.mutate({
        mutation: gql`
          mutation($payload: CreateCrewDeviationInput!) {
            createCrewDeviation(payload: $payload) {
              crew_deviation_uuid
            }
          }
        `,
        variables: {
          payload: {
            ...this.model
          }
        }
      })

      this.createPending = false
      this.$store.commit('crew/create', {
        ...this.model
      })
      this.closeModal()
    },

    closeModal() {
      this.$store.commit('crew/resetModel')
      this.$emit('close')
    }
  }
}
</script>
